import { Switch } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SSwitch = styled(Switch)`
  .ant-switch-inner-checked,
  .ant-switch-inner-unchecked {
    font-size: 16px !important;
    font-family: 'Lato', sans-serif !important;
  }

  &.ant-switch-disabled {
    background-color: #dedede !important;
    cursor: not-allowed;

    .ant-switch-inner-checked,
    .ant-switch-inner-unchecked {
      color: #808080 !important;
    }
  }
`;
